import { render, staticRenderFns } from "./ReferenceFileSelector.vue?vue&type=template&id=387472ab&"
import script from "./ReferenceFileSelector.vue?vue&type=script&lang=js&"
export * from "./ReferenceFileSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports